import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=a8e1b63a&scoped=true&"
import script from "./Next.vue?vue&type=script&lang=js&"
export * from "./Next.vue?vue&type=script&lang=js&"
import style0 from "./Next.vue?vue&type=style&index=0&id=a8e1b63a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e1b63a",
  null
  
)

export default component.exports